import Glide, { Controls, Breakpoints, Images, Swipe, Autoplay  } from '@glidejs/glide/dist/glide.modular.esm'
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

import '../scss/master.scss';
import '@glidejs/glide/dist/css/glide.core.min.css';
import 'lightgallery/css/lightgallery-bundle.css';

var $ = require("jquery");

addEventListener('DOMContentLoaded', (event) => 
{
  if( $('.slider').length > 0 )
  {
    let slider = new Glide('.slider', {
      type: 'carousel',
      autoplay: 5000
    }).mount( { Swipe, Controls, Breakpoints, Images, Autoplay } );
  } 

  if( $('.product-gallery > .glide').length > 0 )
  {
    let pg = new Glide('.product-gallery > .glide', {
      type: 'carousel',
      autoplay: 5000,
      perView: 3,
      gap: 20,
      peek: 50,
      breakpoints: {
        800: {
          perView: 2
        }
      }
    }).mount( { Swipe, Controls, Breakpoints, Images, Autoplay } );
  } 

  if( $('#termek-primary').length > 0  ){
    let profilzoom = lightGallery(document.getElementById('termek-primary'));
  }
  
  if( $('#product-gallery').length > 0  )
  {
    let gallery = lightGallery( 
      document.getElementById('product-gallery'), 
    {
      selector: '.glide__slide:not(.glide__slide--clone)',
      plugins: [lgZoom, lgThumbnail],
      speed: 500,
      download: false
    });
  }

  var menuopened = false;

  $('header .toggle-mobile-menu').on('click', function()
  {
    var opened = $('header .menubar').hasClass('opened');

    if( !opened )
    {
      $('header .menubar').addClass('opened');
      $('body').addClass('menuopened');
      menuopened = true;
    } else {
      $('header .menubar').removeClass('opened');
      $('body').removeClass('menuopened');
      menuopened = false;
    }
  });

  $('header .menubar .closerbar').on('click', function(){
    var opened = $('header .menubar').hasClass('opened');

    if( opened )
    {
      $('header .menubar').removeClass('opened');
      $('body').removeClass('menuopened');
      menuopened = false;
    }
  });

  var lazyloadImages;  
  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          if( entry.target.localName == 'div' )
          {
            var div = entry.target;
            div.classList.remove("lazy")
            div.classList.add("lazyloaded");
            div.style.backgroundImage="url("+div.dataset.src+")";
            imageObserver.unobserve(div);
          } else {
            var image = entry.target;
            image.src = image.dataset.src;
            image.classList.remove("lazy");
            image.classList.add("lazyloaded");
            imageObserver.unobserve(image);
          }
        }
      });
    });

    lazyloadImages.forEach(function(image) {
      imageObserver.observe(image);
    });
  } else {  
    var lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");
    
    function lazyload () {
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }    

      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
            if(img.offsetTop < (window.innerHeight + scrollTop)) {
              img.src = img.dataset.src;
              img.classList.remove('lazy');
            }
        });
        if(lazyloadImages.length == 0) { 
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
});